import React, { Component } from "react";
import { Link } from "react-router-dom";
import data from "../../data/mainData.json";

class Testimonial extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    // show only first 8 videos
    const testimonials = data?.testimonials?.slice(0, 8) || [];

    return (
      <div
        className="ltn__testimonial-area section-bg-1--- bg-image-top pt-115 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          {/* Section Title */}
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Our Testimonial
                </h6>
                <h1 className="section-title">Clients Feedback</h1>
              </div>
            </div>
          </div>

          <div className="row">
            {testimonials.map((item) => (
              <div className="col-lg-3 col-md-6 col-sm-12 mb-30" key={item.id}>
                <div className="ltn__testimonial-item ltn__testimonial-item-7">
                  <div className="ltn__testimoni-info">
                    <div className="ltn__testimonial-video">
                      <video
                        width="100%"
                        height="100%"
                        controls
                        controlsList="nodownload"
                        disablePictureInPicture
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source src={item.video} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                     <p className="text-start mx-3 mb-0 text-wrap" style={{ color: "#2DBB62"}}>Client: <span className="text-dark">{item.name}</span></p>
                     <p className="text-start mx-3 mb-0 text-wrap" style={{ color: "#2DBB62"}}>Published Date: <span className="text-dark">{item.published_date}</span></p>
                </div>
              </div>
            ))}
          </div>

          {/* View More Button */}
          <div className="row">
            <div className="col-lg-12 text-center ">
              
              <Link
              className="btn btn-effect-3 btn-white"
              to="/clients"
            >
              View More <i className="icon-next" />
            </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;
